import { Box, Typography } from "@mui/material"
import { format, parseISO } from "date-fns"
import { SmallLabelledText } from "../../styled/SmallLabelledText"
import { toTitleCase } from "../../../utils/utilityFunctions"

/**
 * 
 * @param {object} props {
 * notes [{status, memoType, dateLogged, note}, ...]
 * }
 */
export function DlspNotes({notes}) {

    if (!notes || !notes.length) {
        return null
    }
    return (
        <Box sx={{mb:4}}>
            <Typography sx={{pb: 1}} variant="body2">Decommissioning Notes</Typography>
            {
            notes.map((n) => {

                const formattedDate = format(parseISO(n.dateLogged), 'd MMMM yyyy')
                const theLabel = `${formattedDate}: ${n.memoType}`
                const theText = `${toTitleCase(n.status)}. ${n.note}`
                return (
                    <SmallLabelledText key={theLabel} label={theLabel} text={theText} />
                )
            })
            }
        </Box>
    )
}